import UserEntity, { UserType } from "../../domain/entities/UserEntity";
import StablishmentDto from "./StablishmentDto";

const stringToRole = (role: string): UserType => {
    switch (role) {
        case "administrador":
            return UserType.ADMIN;
        case 'supervisor':
            return UserType.SUPERVISOR;
        default:
            return UserType.VALET;
    }
}

const roleToString = (role: UserType): string => {
    switch (role) {
        case UserType.ADMIN:
            return "administrador";
        case UserType.SUPERVISOR:
            return "supervisor";
        default:
            return "valet";
    }
}

const fromJSON = (json: any): UserEntity => {
    return {
        id: json['id']?.toString() ?? '',
        name: json['name'] ?? '',
        role: stringToRole(json['role']),
        document: json['document_number'] ?? '',
        documentType: json['document_type'] ?? '',
        phone: json['phone'] ?? '',
        username: json['username'] ?? '',
        email: json['email'] ?? '',
    }
}

const toJson = (user: UserEntity): any => {
    return {
        id: user.id,
        name: user.name,
        role: roleToString(user.role),
        document_number: user.document,
        document_type: user.documentType,
        phone: user.phone,
        username: user.username,
        email: user.email,
    }
}

export default {
    fromJSON,
    toJson,
    roleToString,
    stringToRole,
}